/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IHttpService, ILogService, IPromise, IQService} from 'angular';
import TSEigenleistung from '../../models/TSEigenleistung';
import IRootScopeService = angular.IRootScopeService;

/**
 * Service zum verwalten von Eigenleistungsdaten.
 */
export default class EigenleistungenRS {

    static $inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    /* @ngInject */
    constructor(private $http: IHttpService, private CONSTANTS: any, private $q: IQService,
                private $rootScope: IRootScopeService, private $log: ILogService) {
    }

    public saveEigenleistungen(schadenfallId: string,
                               eigenleistungen?: TSEigenleistung): IPromise<TSEigenleistung | undefined> {
        if (eigenleistungen) {
            let restEigenleistungen: any = eigenleistungen.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'eigenleistungen/' + encodeURIComponent(schadenfallId), restEigenleistungen)
                .then((response) => {
                    if (response.data !== undefined) {
                        return new TSEigenleistung().deserialize(response.data);
                    } else {
                        return undefined;
                    }
                });

        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    }

    public deleteEigenleistung(eigenleistung: TSEigenleistung): IPromise<any> {
        return this.$http.delete(this.CONSTANTS.REST_API + 'eigenleistungen/' + encodeURIComponent(eigenleistung.id))
            .then((response) => {
                return response;
            });
    }

};



// WEBPACK FOOTER //
// ./src/app/core/service/EigenleistungenRS.ts